import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// Estilos
import styles from './institucionalpage.module.css';

// API
import { useInstitucionalService } from '../../services/institucionalService';

// Constantes
import { URLS } from '../../constants/urls';

function InstitucionalPage() {
    const navigate = useNavigate();

    const { logout } = useAuth();
    const { showToast } = useToast();
    const { showLoader, hideLoader } = useLoader();
    const { showModal } = useModal();

    const { listarTodosInstitucionais } = useInstitucionalService();
    const [conteudos, setConteudos] = useState([]);

    useEffect(() => {
        const carregarConteudo = async () => {
            showLoader("Carregando conteúdos institucionais");

            const res = await listarTodosInstitucionais();

            if (!res.success) {
                showToast("Erro ao carregar institucional", 3000, 'error');
                if (res.message?.toLowerCase().includes('token')) logout();
                hideLoader();
                return;
            }

            // Reestrutura para exibir lado a lado
            const agrupado = {
                sante: { titulo: 'Sobre a Santé', tipo: 'sante' },
                livro: { titulo: 'Livro', tipo: 'livro' }
            };

            res.data.forEach(item => {
                const key = item.nome;
                if (!agrupado[key]) return;

                if (item.tipo === 'descricao') {
                    agrupado[key].descricao = item.valor;
                    agrupado[key].data_descricao = item.momento;
                } else if (item.tipo === 'video') {
                    agrupado[key].video = `${URLS.IMG_PATH}${item.valor}`;
                    agrupado[key].data_video = item.momento;
                }
            });

            setConteudos(Object.values(agrupado));
            hideLoader();
        };

        carregarConteudo();
    }, []);

    const handleEditar = (item) => {
        navigate(`/institucional/atualizar/${item.tipo}`);
    };

    return (
        <div className={styles.InstitucionalPage}>
            <div className={styles.containerTop}>
                <Breadcrumbs />
                <h1 className={styles.title}>Informações Institucionais</h1>
                
                <FriendlyPhrase page={"institucional"} />
            </div>

            <div className={styles.containerList}>
                {conteudos.map((item) => (
                    <div key={item.tipo} className={styles.card}>
                        <h2>{item.titulo}</h2>
                        <p>{item.descricao}</p>
                        {item.video ? (
                            <video className={styles.video} controls src={item.video}></video>
                        ) : (
                            <p><em>Vídeo não disponível</em></p>
                        )}
                        <p><strong>Momento (descrição):</strong> {item.data_descricao || '---'}</p>
                        <p><strong>Momento (vídeo):</strong> {item.data_video || '---'}</p>
                        <button className={styles.editar} onClick={() => handleEditar(item)}>Editar</button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default InstitucionalPage;